// extracted by mini-css-extract-plugin
export var externalLink = "_bn-0";
export var internalLinkLabel = "_bn-1";